// extracted by mini-css-extract-plugin
export default {"cardAttach":"messageBoxEven_cardAttach__zCzfz","messageSender":"messageBoxEven_messageSender__mJ8nC"};